<template>
	<div >
	  <div class='gPageBorder'>
		<p class="gPTitle">{{$t('terminal.terRisk.fkpz')}}</p>
		<el-table class='' :data="tableData" border style="">
			<el-table-column prop="controlName" :label="$t('lin_global.risk_name')" width="200">

			</el-table-column>
			<el-table-column prop="messageName" :label="$t('lin_global.risk_type')" width="150">

			</el-table-column>
			<!-- <el-table-column prop="" label="经纬度" width="">

			</el-table-column> -->
			<el-table-column prop="radius" :label="$t('lin_global.risk_radius')" width="130">

			</el-table-column>
			<el-table-column :formatter="cityFormat" :label="$t('lin_global.risk_city')" width="150">

			</el-table-column>
			<el-table-column prop="controlDesc" :label="$t('lin_global.risk_desc')" width="">

			</el-table-column>
		</el-table>
	  </div>
		<!-- <div style="width: 100%;border-bottom: 1px solid #ccc;margin-bottom: 20px;"></div> -->

	  <div class='gTopMg gPageBorder'>
		<p class='gPTitle'>{{$t('lin_global.risk_warn_info')}}</p>
		<el-table :data="tableData2" border>
			<el-table-column prop="terminalName" :label="$t('lin_global.label_name')">

			</el-table-column>
			<el-table-column prop="terminalNo" :label="$t('lin_global.label_no')" width="150">

			</el-table-column>

			<el-table-column prop="eventType" :formatter="formatStatus" :label="$t('lin_global.warn_event')" width="100">

			</el-table-column>
			<el-table-column prop="timeNow" :label="$t('lin_global.time')" width="180">

			</el-table-column>
			<el-table-column prop="cityNow" :label="$t('lin_global.city')" width="100">

			</el-table-column>
			<el-table-column prop="longitudeAndlatitude" :label="$t('lin_global.jwd')" width="200">

			</el-table-column>
			<el-table-column prop="outDistance" :label="$t('lin_global.distance')" width="150">

			</el-table-column>
			<el-table-column prop="status" :formatter="formatStatus1" :label="$t('lin_global.status')" width="100">

			</el-table-column>
		</el-table>
	  </div>
	</div>
</template>
<script>
	import axios from 'axios'
	import {baseurl} from '../../api/url'
	export default{
		data(){
			return{
				orderName: '',
				orderType: '',
				terminalID:this.$route.params.id,
				tableData:[],
				tableData2:[]
			}
		},
		created(){
			
			this.getData();
		},
		methods:{
      cityFormat:function(row){
        if(row.city){
          var value = row.city.split(',')[0];
          return value
        }

      },
			formatStatus:function(row,column){
				return row.eventType == 0?this.$t('lin_global.ccwl'):row.eventType == 1?this.$t('lin_global.sbyj'):'';
			},
			formatStatus1:function(row,column){
				return row.status == 0?this.$t('lin_global.undone'):row.status == 1?this.$t('lin_global.done'):'';
			},
			getData () {
				var params = {orderName: this.orderName, orderType: this.orderType,page:1,rows:10000,controllerName:'',messageId:'',terminalId:this.terminalID}
				axios.post(`${baseurl}/risk/listController.do`,params).then(res=>{
					//console.log("打印返回列表");
					//console.log(res.data);
					this.tableData = res.data.data;
				})
				var params2 = { page:1,rows:10000,distributorId:'',terminalId:this.terminalID}
				axios.post(`${baseurl}/risk/listByTerminalIdwarning.do`,params2).then(res=>{
					//console.log("打印返回列表2");
					//console.log(res.data);
					this.tableData2 = res.data.data;
				})
			}
		}
	}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// terRisk.vue?9ace0d44